import React, {Component} from 'react';
import {Form, Card, Button, Row, Col, Container} from 'react-bootstrap';
import SelectDept from './FormFields/SelectDept';
import SelectImpact from './FormFields/SelectImpact';
import SelectEmployment from './FormFields/SelectEmployment';
import SelectMajorArea from './FormFields/SelectMajorArea';
import SelectName from './FormFields/SelectName';
import Select3E from './FormFields/Select3E';

class SearchForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            searchParams: {
                departments: [],
                impacts: [],
                employments: [],
                majors: [],
                eTags: []
            },
            selectedName: '',
            selectedDepts: [],
            selectedImpacts: [],
            selectedEmployments: [],
            selectedMajors: [],
            selectedETag: null,
        }
        this.search = this.search.bind(this);
        this.getSearchParams();
    }

    getSearchParams = () => {
        let url = process.env.PUBLIC_URL + '/api/Search/GetParams';
        fetch(url).then(response => response.json()).then(data => {
            for (let key in data) {
                data[key] = data[key].filter(function (ele) {
                    return ele.text !== "-";
                });
                if (key === "eTags") {
                    data[key] = data[key].reverse();
                }
            }
            this.setState({searchParams: data});
        })
    }

    search = () => {
        this.props.search(this.state.selectedName, this.state.selectedDepts, this.state.selectedImpacts,
            this.state.selectedEmployments, this.state.selectedMajors, this.state.selectedETag);
    }

    render() {
        return (
            <div style={{
                marginTop: '15px'
            }}>
                <Form onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                        this.search();
                    }
                }}>
                    <Row>
                        <SelectName name={this.state.selectedName}
                                    setName={(val) => this.setState({selectedName: val})}/>
                        <SelectDept depts={this.state.searchParams.departments}
                                    setDepts={(val) => this.setState({selectedDepts: val})}/>
                    </Row>
                    <Row>
                        <SelectImpact impacts={this.state.searchParams.impacts}
                                      setImpacts={(val) => this.setState({selectedImpacts: val})}/>
                        <SelectEmployment employments={this.state.searchParams.employments}
                                          setEmployments={(val) => this.setState({selectedEmployments: val})}/>
                    </Row>
                    <Row>
                        <SelectMajorArea majors={this.state.searchParams.majors}
                                         setMajors={(val) => this.setState({selectedMajors: val})}/>
                        <Select3E eTags={this.state.searchParams.eTags}
                                  setETag={(val) => {
                                      this.setState({selectedETag: val})
                                  }}/>
                    </Row>
                    <Row>
                        <Col>
                            <Button className="float-right" style={{marginTop: '10px'}} onClick={this.search}>Search</Button>
                        </Col>
                    </Row>
                </Form>
            </div>
        )
    }
}

export default SearchForm;



// WEBPACK FOOTER //
// ./src/components/Search/SearchForm.js